import {Logo} from "components"
import React from "react";

const ListItem = ({group, setCheck = f => f, showAvailableTime = f => f,selectGroup = f => f,showNew}) => {
    const unCheckedGroupAllCheck = group.data.some(item => item.checked !== true)
    
    return (
        <li>
            <div className=" flex-justify_between" id={group.indstCd}>
                <div className="check-title">{group.indstCd.toLowerCase() === "kinfa" ? "공공기관" : group.indstNm}
                 <span>{group.count}</span>
                 </div>
                 <div 
                    className={` text-align_right `}
                    onClick={() => selectGroup(group.indstCd,undefined,unCheckedGroupAllCheck)}
                >
                    <span className="chk">
                        <i className={`checkMark${!unCheckedGroupAllCheck ? " on" : ""}`} />
                    </span>
                    {!unCheckedGroupAllCheck ? "전체해제" : "전체선택"}
                </div>
            </div>
            {
                group.data.map(item => {

                    const itemIsAvailableTime = item.isAvailableTime;
                    const getOnclick = () => {
                        if (itemIsAvailableTime) {
                            return setCheck(item.insttCd);
                        } else {
                            return showAvailableTime(item);
                        }
                    }
                    const getClassName = () => {
                        if (itemIsAvailableTime) {
                            return `checkMark${item.checked === true ? " on" : ""}`;
                        } else {
                            return "icon icon_question";
                        }
                    }

                    return (
                        <div key={item.insttCd} className="check-list" onClick={getOnclick}>
                            <div>
                                <div>
                                    <div className="img-box img-symbol">
                                        <Logo code={item.insttCd} style={{width: "100%", height: "100%"}}/>
                                    </div>
                                    <p className="ml_10 ellipsis" style={{width: "17rem"}}>{item.insttNm}</p>
                                </div>
                                <div>
                                    {
                                        item.linked && <span className="connect mr_10">연결됨</span>
                                    }
                                    {
                                        (showNew && !item.linked && item.isNew) && <span className="new mr_10">신규기관</span>
                                    }
                                    <div className="chk">
                                        <i className={getClassName()}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )

                })
            }
        </li>
    )
}

export default ListItem